import { useMutation, useQuery, useQueryClient } from "react-query";
import useApiHelper from "../../services/useApiHelper";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import { windowDisplaysQueryKeys } from "./queryKeys";
import { IWindowDisplay, WindowDisplayCreate, WindowDisplayUpdate } from "../../models/windowDisplay/WindowDisplay";

export function useWindowDisplays(agencyId: string) {
    const queryClient = useQueryClient();
  const { get, post, put, del  } = useApiHelper();
  

  const windowDisplay = useQuery({
    queryKey: windowDisplaysQueryKeys.all(agencyId),
    queryFn: () =>
      get(`/windowdisplay/${agencyId}`) as unknown as IDefaultResponseWithData<IWindowDisplay>,
    refetchOnWindowFocus: false,
    enabled: !!agencyId,
  });

  const create = useMutation(
    (data: WindowDisplayCreate) => post(`/windowdisplay/${agencyId}`, data),
    {
      onSuccess: (_) => {
        queryClient.invalidateQueries(windowDisplaysQueryKeys.all(agencyId));
      },
    }
  );

  const update = useMutation(
    (data: WindowDisplayUpdate) =>
      put(`/windowdisplay/${data.id}`, data),
    {
      onSuccess: (_) => {
        queryClient.invalidateQueries(windowDisplaysQueryKeys.all(agencyId));
      },
    }
  );

  const remove = useMutation(
    (id: string) => del(`/windowdisplay/${id}`),
    {
      onSuccess: (_) => {
        queryClient.invalidateQueries(windowDisplaysQueryKeys.all(agencyId));
      },
    }
  );

  return { windowDisplay, create, update, remove };
}


